	angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListComunicateDemConfirmationController',
	function(
		$rootScope, $scope, $state, $stateParams, $filter, $timeout,
		$confirm,
		InvitationListComunicateService, FileUploader, getBaseApiURL, Session
	) {

	$scope.id       = $stateParams.id;
	$scope.event_id = $stateParams.event_id;
	$scope.showPremio2021 = false;

	$scope.tinymceOptionsReady = false;

	$scope.tinymceOptionsEmailSubjectDem = angular.copy($rootScope.tinymceOptionsEmailSubject);
	$scope.tinymceOptionsEmailBodyDem = angular.copy($rootScope.tinymceOptionsEmailBody);

	$scope.attachmentTags = [];

	$rootScope.getInvitationList($stateParams.id);

	$rootScope.getServicesUsers();

	$rootScope.getEvent( $stateParams.event_id );

	$scope.$on( 'event_tag_loaded', function() {

		var tinymceValues = [
			{ text: 'Nome', value: '{FIRST_NAME}' },
			{ text: 'Cognome', value: '{LAST_NAME}' },
			{ text: 'Data Tappa Da', value: '{FIRST_STAGE_DAY_FROM}' },
			{ text: 'Data Tappa A', value: '{FIRST_STAGE_DAY_TO}' },
			{ text: 'Orario Tappa Da', value: '{FIRST_STAGE_TIME_FROM}' },
			{ text: 'Orario Tappa A', value: '{FIRST_STAGE_TIME_TO}' },
			{ text: 'Nome Location', value: '{LOCATION_NAME}' },
			{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
			{ text: 'Nome Agenzia', value: '{AGENCY_NAME}' },
		];

		$scope.attachmentTags = [];

		angular.forEach($rootScope.eventTagData, function(tag, key) {
			if ( tag.type === 'text' ) {
				var value = tag.tag.toLowerCase();
				value = value.replace(' ', '_');
				value = value.replace('à', 'a');
				value = value.replace('è', 'e');
				value = value.replace('é', 'e');
				value = value.replace('ì', 'i');
				value = value.replace('ò', 'o');
				value = value.replace('ù', 'u');
				value = value.replace(/[^a-zA-Z0-9]/g, '_');
				value = value.toUpperCase();

				tinymceValues.push({text: tag.tag, value: '{' + value + '}'});
			} else if ( tag.type === 'attachment' ) {
				$scope.attachmentTags.push( {
					text: tag.tag,
					value: 'tag_' + tag.id,
					state: $scope.invitationListData.dem_confirm_attachment_tags.includes( 'tag_' + tag.id )
				} );
			}
		});

		$scope.tinymceOptionsEmailSubjectDem.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});
		};

		$scope.tinymceOptionsEmailBodyDem.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});

			editor.addButton('sections_btn', {
				type: 'listbox',
				text: 'Placeholders Sezioni',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					// { text: 'Pulsante Azione', value: '{{UNICA_ACTION_CTA}}' },
					// { text: 'Sezione Hospitality', value: '{{UNICA_HOSPITALITY}}' },
					// { text: 'Sezione Transfer', value: '{{UNICA_TRANSFER}}' },
					{ text: 'Sezione Dati Registrazione', value: '{{UNICA_REGISTRATION_DATA}}' }
				],
				onPostRender: function () {
				}
			});
		};


		$scope.tinymceOptionsReady = true;

	});

	$scope.$on( 'invitation_list_loaded', function() {
		$scope.showPremio2021 = [
			44, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207
		].includes( $rootScope.invitationListData.event_id );

		$scope.invitationListData.dem_confirm_attachment_tags =
			$scope.invitationListData.dem_confirm_attachment_tags ? $scope.invitationListData.dem_confirm_attachment_tags.split(',') : [];

		$rootScope.getEventTags( $stateParams.event_id );
	});


	/**
	 * FUNCTIONS FOR CHECK THE FORM AND SAVE THE DEM CONFIRMATION
	 */

	$scope.checkDemConfirmationForm = function() {
		if ( !$scope.forms.dem_confirm_form.$invalid &&
			 $rootScope.invitationListData &&
			 $rootScope.invitationListData.dem_confirm && $rootScope.invitationListData.dem_confirm.dataURL != '' ) {
			return false;
		}
		return true;
	};

	$scope.saveDemConfirmation = function() {
		$rootScope.invitationListData.dem_confirm = $rootScope.invitationListData.dem_confirm.dataURL;

		if ( $rootScope.invitationListData.dem_confirm_logo && $rootScope.invitationListData.dem_confirm_logo.dataURL ) {
			$rootScope.invitationListData.dem_confirm_logo = $rootScope.invitationListData.dem_confirm_logo.dataURL;
		} else {
			$rootScope.invitationListData.dem_confirm_logo = '';
		}

		var invitationListData = angular.copy($rootScope.invitationListData);


		invitationListData.dem_confirm_attachment_tags = [];

		angular.forEach($scope.attachmentTags, function(attachmentTag, key) {
			if ( attachmentTag.state ) {
				invitationListData.dem_confirm_attachment_tags.push(attachmentTag.value);
			}
		});

		invitationListData.dem_confirm_attachment_tags = invitationListData.dem_confirm_attachment_tags.join(',');

		InvitationListComunicateService
			.updateDemConfirmation(invitationListData)
			.then(function(data) {

				$scope.hideLoader();

				if ( data ) {
					$rootScope.getInvitationList($scope.id);

					$scope.showSuccessMsg('Email di Conferma aggiornata con successo!', '');
				}
			});
	};





	/**
	 * FUNCTIONS FOR UPLOAD ATTACHMENTS AND IMAGES
	 */

	$scope.changeInvitationListDemConfirmation = function()
	{
		$rootScope.showLoader();
		$rootScope.invitationListData.dem_confirmation_changed = true;
	};

	$scope.changeInvitationListDemConfirmationLogo = function()
	{
		$rootScope.showLoader();
		$rootScope.invitationListData.dem_confirmation_logo_changed = true;
	};

	$scope.$watch('$root.invitationListData.dem_confirm', function() {
		$rootScope.hideLoader();
	});

	$scope.$watch('$root.invitationListData.dem_confirm_logo', function() {
		$rootScope.hideLoader();
	});

	$scope.programUploader = new FileUploader({
		autoUpload: true,
		removeAfterUpload: true,
		alias: 'dem_program',
		url: getBaseApiURL + '/invitation-list/update-dem-confirmation-program/' + $stateParams.id,
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.programUploader.onCompleteItem = function(fileItem, response) {
		$rootScope.getInvitationList($scope.id);
	};

	$scope.changeInvitationListProgram = function() {
		$rootScope.invitationListData.program_changed = true;
		$scope.programUploader.formData.push({ 'program_changed' : $rootScope.invitationListData.program_changed });
	};


	$scope.privacyUploader = new FileUploader({
		autoUpload: true,
		removeAfterUpload: true,
		alias: 'dem_privacy',
		url: getBaseApiURL + '/invitation-list/update-dem-confirmation-privacy/' + $stateParams.id,
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.privacyUploader.onCompleteItem = function(fileItem, response) {
		$rootScope.getInvitationList($scope.id);
	};

	$scope.changeInvitationListPrivacy = function() {
		$rootScope.invitationListData.privacy_changed = true;
		$scope.privacyUploader.formData.push({ 'privacy_changed' : $rootScope.invitationListData.privacy_changed });
	};





	/**
	 * FUNCTIONS FOR REMOVE ATTACHMENTS AND IMAGES
	 */

	$scope.deleteDemProgram = function() {
		$scope.showLoader();
		InvitationListComunicateService
			.deleteDemConfirmationProgram( $rootScope.invitationListData.id )
			.then(function(data) {

				$scope.hideLoader();

				if ( data ) {
					$rootScope.getInvitationList($scope.id);

					$scope.showSuccessMsg('Programma rimosso con successo!', '');
				}
			});
	};

	$scope.deleteDemPrivacy = function() {
		$scope.showLoader();
		InvitationListComunicateService
			.deleteDemConfirmationPrivacy( $rootScope.invitationListData.id )
			.then(function(data) {

				$scope.hideLoader();

				if ( data ) {
					$rootScope.getInvitationList($scope.id);

					$scope.showSuccessMsg('Privacy rimossa con successo!', '');
				}
			});
	};

	$scope.removeDemConfirmation = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'immagine di copertina della email di conferma invito?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();
			InvitationListComunicateService
				.deleteDemConfirmation( $stateParams.id  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						// $rootScope.getInvitationList($scope.id);

						$rootScope.invitationListData.dem_confirm = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Immagine Email Conferma Invito eliminata con successo!', '');
					}
				});

		}, function() { });
	};


	$scope.removeDemConfirmationLogo = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il logo della email di conferma invito?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();
			InvitationListComunicateService
				.deleteDemConfirmationLogo( $stateParams.id  )
				.then(function(data) {

					$scope.hideLoader();

					if ( data ) {
						// $rootScope.getInvitationList($scope.id);

						$rootScope.invitationListData.dem_confirm_logo = null;

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Logo Email Conferma Invito eliminato con successo!', '');
					}
				});

		}, function() { });
	};




	/**
	 * FUNCTIONS FOR AUTOCOMPLETE USER FOR PREVIEW
	 */

	$scope.searchText = '';

	$scope.searchServiceUser = function(query) {
		return query ? $filter('filter')($rootScope.servicesUsers, {label: query}) : $rootScope.servicesUsers;
	};

	$scope.selectedServiceUser = function(service) {
		if ( service ) {
			$scope.previewDemData.user_id = service.id;
		} else {
			$scope.previewDemData.user_id = null;
		}
	};





	/**
	 * FUNCTIONS FOR PREVIEW FUNCTIONALITY
	 */
	$scope.previewDemData = {
		user_id: null
	};

	$scope.checkPreviewDemForm = function() {
		return ( !$scope.previewDemData.user_id ? true : false );
	};

	$scope.previewDemConfirmation = function() {
		InvitationListComunicateService
			.previewDemConfirmation( $rootScope.invitationListData.id, $scope.previewDemData.user_id )
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Anteprima inviata con successo!', '');
				}
			});
	};

});
